import List from './List'

const carsTireResource = {
  list: List,
}

export default carsTireResource
